import { useState, useEffect } from "react";
import { Button, InputNumber, Space } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const QuantityInput = ({
    value,
    onChange,
    min = 0,
    max,
    size = "large",
    disabled = false,
    className,
}) => {
    const [internal, setInternal] = useState(value);

    useEffect(() => {
        setInternal(value);
    }, [value]);

    const handleIncrease = () => {
        const next = Math.min((internal || 0) + 1, max ?? Infinity);
        setInternal(next);
        onChange(next);
    };

    const handleDecrease = () => {
        const next = Math.max((internal || 0) - 1, min);
        setInternal(next);
        onChange(next);
    };

    const handleKeyDown = (e) => {
        if (
            !(
                (e.key >= "0" && e.key <= "9") ||
                ["Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"].includes(e.key)
            )
        ) {
            e.preventDefault();
        }
    };

    return (
        <Space.Compact block className={className}>
            <Button
                icon={<MinusOutlined />}
                onClick={handleDecrease}
                disabled={disabled || internal <= min}
                size={size}
            />

            <InputNumber
                size={size}
                min={min}
                max={max}
                value={internal}
                onChange={(val) => {
                    const next = val ?? min;
                    setInternal(next);
                    onChange(next);
                }}
                className="w-full quantity-input"
                controls={false}
                disabled={disabled}
                onKeyDown={handleKeyDown}
            />

            <Button
                icon={<PlusOutlined />}
                onClick={handleIncrease}
                disabled={disabled || (max !== undefined && internal >= max)}
                size={size}
            />
        </Space.Compact>
    );
};

export default QuantityInput;
